"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var dgc_logo_v1_png_1 = __importDefault(require("@assets/widgets/app/dgc-logo-v1.png"));
var mptc_logo_v1_png_1 = __importDefault(require("@assets/widgets/app/mptc-logo-v1.png"));
var go_main_logo_light_svg_1 = __importDefault(require("@assets/go-logo-graphics/go-main-logo-light.svg"));
var facebook_svg_1 = __importDefault(require("@assets/widgets/app/social-media/facebook.svg"));
var telegram_svg_1 = __importDefault(require("@assets/widgets/app/social-media/telegram.svg"));
var linkedin_svg_1 = __importDefault(require("@assets/widgets/app/social-media/linkedin.svg"));
var youtube_svg_1 = __importDefault(require("@assets/widgets/app/social-media/youtube.svg"));
var twitter_svg_1 = __importDefault(require("@assets/widgets/app/social-media/twitter.svg"));
var emailIcon_svg_1 = __importDefault(require("@assets/widgets/app/emailIcon.svg"));
var locationIcon_svg_1 = __importDefault(require("@assets/widgets/app/locationIcon.svg"));
var Footer_1 = __importDefault(require("../BaseFooter/Footer"));
var NewBaseFooter = function () {
    var t = react_i18next_1.useTranslation().t;
    var images = {
        appLogo: go_main_logo_light_svg_1.default,
    };
    var labels = {
        appTitle: t('general.appCatchphrase.noStyle'),
        contactUs: t('general.contactUs'),
        appCredit: t('general.copyright'),
    };
    var contacts = {
        email: 'support@dgc.gov.kh',
    };
    var address = {
        location: t('general.address'),
        code: '',
        emailIcon: react_1.default.createElement("img", { src: emailIcon_svg_1.default, alt: "email", width: "16" }),
        mapIcon: react_1.default.createElement("img", { src: locationIcon_svg_1.default, alt: "map", width: "16" }),
    };
    var buildBy = {
        title: t('text.builtBy'),
        items: [
            {
                name: 'mptc-logo',
                link: 'https://mptc.gov.kh/',
                logo: mptc_logo_v1_png_1.default,
            },
            {
                name: 'dgc-logo',
                link: 'https://go.gov.kh/dgc/site',
                logo: dgc_logo_v1_png_1.default,
            },
        ],
    };
    var footerLinks = [
        {
            name: 'term-of-use',
            link: t('general.links.terms'),
            label: t('general.termsOfUse'),
        },
        {
            name: 'privacy',
            link: t('general.links.privacy'),
            label: t('general.privacy'),
        },
    ];
    var socialLinks = [
        {
            name: 'Facebook',
            link: 'https://go.gov.kh/dgc/fb',
            icon: react_1.default.createElement("img", { src: facebook_svg_1.default, alt: "facebook", width: "16" }),
        },
        {
            name: 'Telegram',
            link: 'https://go.gov.kh/dgc/tg',
            icon: react_1.default.createElement("img", { src: telegram_svg_1.default, alt: "telegram", width: "16" }),
        },
        {
            name: 'Linkedin',
            link: 'https://go.gov.kh/dgc/lnkd',
            icon: react_1.default.createElement("img", { src: linkedin_svg_1.default, alt: "linkedIn", width: "16" }),
        },
        {
            name: 'Youtube',
            link: 'https://www.youtube.com/@MPTCMedia',
            icon: react_1.default.createElement("img", { src: youtube_svg_1.default, alt: "youtube", width: "16" }),
        },
        {
            name: 'Twitter',
            link: 'https://twitter.com/mptcgovkh',
            icon: react_1.default.createElement("img", { src: twitter_svg_1.default, alt: "twitter", width: "16" }),
        },
    ];
    return (react_1.default.createElement(Footer_1.default, { images: images, labels: labels, contacts: contacts, address: address, buildBy: buildBy, footerLinks: footerLinks, socialLinks: socialLinks }));
};
exports.default = NewBaseFooter;
